const formatType = (type) => {
  switch (type) {
    case 4:
      return 'couriers';
    case 3:
      return 'fundraisers';
    case 2:
      return 'clean-water-corps';
    case 1:
    default:
      return 'programs';
  }
};

export default formatType;
